module.exports = __webpack_public_path__ + "img/DENT.6e367d61.svg";